/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AssignQueueResponse } from '../../models/assign-queue-response';

export interface ApiIdpQueueAssignQueuePost$Params {
      body?: Array<number>
}

export function apiIdpQueueAssignQueuePost(http: HttpClient, rootUrl: string, params?: ApiIdpQueueAssignQueuePost$Params, context?: HttpContext): Observable<StrictHttpResponse<AssignQueueResponse>> {
  const rb = new RequestBuilder(rootUrl, apiIdpQueueAssignQueuePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AssignQueueResponse>;
    })
  );
}

apiIdpQueueAssignQueuePost.PATH = '/api/IdpQueue/assign-queue';
